module.exports = __webpack_public_path__ + "img/custom-6.f9dc2828.svg";